import type { IconSvgObject } from './types';

const TrapezoidLineHorizontalIcon: IconSvgObject = [
  ["path", { d: "M16.7171 4.82618L6.71894 6.25471C5.73381 6.39546 5.00203 7.23907 5.00183 8.23421L5.00034 15.7651C5.00015 16.7605 5.73206 17.6046 6.7175 17.7454L16.7172 19.1739C17.922 19.346 19 18.4111 19 17.194V6.80607C19 5.58895 17.922 4.65402 16.7171 4.82618Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12L2 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TrapezoidLineHorizontalIcon;
